import { render, staticRenderFns } from "./multiTest.vue?vue&type=template&id=0c6f997b&scoped=true&"
import script from "./multiTest.vue?vue&type=script&lang=js&"
export * from "./multiTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6f997b",
  null
  
)

export default component.exports